import React, { Component } from 'react';
import { Modal, Button, Row, Col } from 'antd';
import CopyToClipboard from 'react-copy-to-clipboard';

class CopyDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            copied: false
        }
    }

    close = () => {
        this.setState({showModal: false, copied: false});
    }

    open = () => {
        this.setState({showModal: true, copied: false});
    }

    copy = () => {
        this.setState({copied: true});
    }

    render() {
        const { copied } = this.state;
        const { appID, secret, title } = this.props;

        return (
            <Modal visible={this.state.showModal} title={title} width={ 550 }
                   closable={ false } maskClosable={false} style={{ top: 70 }}
                   footer={[
                        <Button type="primary" key="cancel" size="large" onClick={this.close} disabled={!copied}>Close</Button>
                   ]}>
                <div style={{marginBottom: 20}}>
                    Copy and save the {appID && 'App ID and '}secret below.
                    You can't access the secret again once you close this modal.
                </div>
                { appID && (
                    <Row gutter={10} style={{marginBottom: 10}}>
                        <Col span={3}>App ID:</Col>
                        <Col span={18}><div style={{wordBreak: 'break-all'}}>{appID}</div></Col>
                        <Col span={2}>
                            <CopyToClipboard text={appID}>
                                <a className="glyphicon glyphicon-duplicate"
                                   style={{marginLeft: 10, fontSize: 16}} title="Copy to Clipboard"></a>
                            </CopyToClipboard>
                        </Col>
                    </Row>
                )}
                <Row gutter={10}>
                    <Col span={3}>Secret:</Col>
                    <Col span={18}><div style={{wordBreak: 'break-all'}}>{secret}</div></Col>
                    <Col span={2}>
                        <CopyToClipboard text={secret}>
                            <a className="glyphicon glyphicon-duplicate" onClick={this.copy}
                               style={{marginLeft: 10, fontSize: 16}} title="Copy to Clipboard"></a>
                        </CopyToClipboard>
                    </Col>
                </Row>
            </Modal>
        )
    }

}

export default CopyDialog;


// WEBPACK FOOTER //
// ./src/modules/appstore/CopyDialog.js